// extracted by mini-css-extract-plugin
module.exports = {"content":"styles-module--content--2p69C","appear":"styles-module--appear--37EGu","text":"styles-module--text--3be9n","icon":"styles-module--icon--2faXd"};